import api from '@/lib/api';
import type { TodoPersonalChecklistItemResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useChecklist } from './useChecklist';

/**
 * The checklist of a single PRIVATE personal task (My Tasks overlay). Mirrors
 * {@link useTodoChecklist} on the per-user `vault_todo_personal_checklist_items`
 * table; mutations refresh the checklist and the personal board so the badge
 * stays current. Thin wrapper over the shared {@link useChecklist} engine.
 */
export function usePersonalChecklist(
  holderId: string | null,
  listId: string,
  personalItemId: string | null,
  enabled = true,
) {
  return useChecklist<TodoPersonalChecklistItemResponse>({
    holderId,
    id: personalItemId,
    enabled,
    key:
      holderId && personalItemId
        ? queryKeys.todoLists.personalChecklist(holderId, listId, personalItemId)
        : ['todoLists', 'personalChecklist', 'disabled'],
    secondaryKey: (h) => queryKeys.todoLists.personalBoard(h, listId),
    list: (h, id) => api.getTodoPersonalChecklist(h, id),
    create: (h, id, title) => api.createTodoPersonalChecklistItem(h, id, title),
    setDone: (h, checklistItemId, isDone) =>
      api.updateTodoPersonalChecklistItem(h, checklistItemId, { isDone }),
    remove: (h, checklistItemId) => api.deleteTodoPersonalChecklistItem(h, checklistItemId),
    reorder: (h, id, order) => api.reorderTodoPersonalChecklist(h, id, order),
  });
}
